import { createAsyncThunk } from '@reduxjs/toolkit';
import OrgRolesAPI from './orgRolesApi';

export const fetchOrgRolesThunk = createAsyncThunk(
  'orgRoles/fetchRoles',
  async (_, { rejectWithValue }) => {
    try {
      return await OrgRolesAPI.fetchRoles();
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to load org roles');
    }
  }
);

export const createOrgRoleThunk = createAsyncThunk(
  'orgRoles/createRole',
  async (roleData, { rejectWithValue }) => {
    try {
      return await OrgRolesAPI.createRole(roleData);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to create org role');
    }
  }
);

export const updateOrgRoleThunk = createAsyncThunk(
  'orgRoles/updateRole',
  async ({ roleId, updates }, { rejectWithValue }) => {
    try {
      return await OrgRolesAPI.updateRole(roleId, updates);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to update org role');
    }
  }
);

export const deleteOrgRoleThunk = createAsyncThunk(
  'orgRoles/deleteRole',
  async (roleId, { rejectWithValue }) => {
    try {
      return await OrgRolesAPI.deleteRole(roleId);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to delete org role');
    }
  }
);

export const fetchOrgRoleHoldersThunk = createAsyncThunk(
  'orgRoles/fetchHolders',
  async (roleId, { rejectWithValue }) => {
    try {
      return await OrgRolesAPI.fetchHolders(roleId);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to load role holders');
    }
  }
);

export const mapUserToOrgRoleThunk = createAsyncThunk(
  'orgRoles/mapUser',
  async ({ roleId, userId }, { rejectWithValue }) => {
    try {
      return await OrgRolesAPI.mapUser(roleId, userId);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to map user to role');
    }
  }
);

export const unmapUserFromOrgRoleThunk = createAsyncThunk(
  'orgRoles/unmapUser',
  async ({ roleId, userId }, { rejectWithValue }) => {
    try {
      return await OrgRolesAPI.unmapUser(roleId, userId);
    } catch (err) {
      return rejectWithValue(err?.response?.data?.detail || err.message || 'Failed to unmap user from role');
    }
  }
);
